import { render, staticRenderFns } from "./tableSetting-.vue?vue&type=template&id=ac60d72a&scoped=true"
import script from "./tableSetting-.vue?vue&type=script&lang=js"
export * from "./tableSetting-.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac60d72a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac60d72a')) {
      api.createRecord('ac60d72a', component.options)
    } else {
      api.reload('ac60d72a', component.options)
    }
    module.hot.accept("./tableSetting-.vue?vue&type=template&id=ac60d72a&scoped=true", function () {
      api.rerender('ac60d72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableSetting-.vue"
export default component.exports